import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcGridHeaderFilterMenu]'
})
export class GridHeaderFilterMenuDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
